/**
 * @generated SignedSource<<5511ce0ec9c9e94a5cd619574ca230fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmaginItem_IntegrationEmaginFlyer$data = {
  readonly eMaginId: string | null;
  readonly id: string;
  readonly imageUrls: ReadonlyArray<string>;
  readonly title: string | null;
  readonly " $fragmentType": "EmaginItem_IntegrationEmaginFlyer";
};
export type EmaginItem_IntegrationEmaginFlyer$key = {
  readonly " $data"?: EmaginItem_IntegrationEmaginFlyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmaginItem_IntegrationEmaginFlyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmaginItem_IntegrationEmaginFlyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eMaginId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrls",
      "storageKey": null
    }
  ],
  "type": "IntegrationEmaginFlyer",
  "abstractKey": null
};

(node as any).hash = "e453c6929890f95ea22c8095f5178f32";

export default node;
